
import React, { useState } from "react";

const BusinessAppSection = () => {
  const [imageSrc, setImageSrc] = useState(
    "/assests/images/LandingPage/vendor/ip-dashboard-feature.png"
  );
  const [activeFeature, setActiveFeature] = useState("Intuitive Dashboard");

  const handleHover = (image, id) => {
    console.log(id); // Optional log for feature id
    setImageSrc(image);
  };

  const handleMouseLeave = () => {
    setImageSrc("/assests/images/LandingPage/vendor/ip-dashboard-feature.png");
  };

  const features = [
    {
      title: "Intuitive Dashboard",
      description:
        "Easily manage your ongoing projects, track payment status, and access all essential tools in one place, designed specifically for installation partners.",
      image: "/assests/images/LandingPage/vendor/ip-dashboard-feature.png", // Sample image
    },
    {
      title: "Get Job Opportunities Near To You",
      description:
        "Get access to the world of new opportunities. Get notified when a new job is published near to your location.",
      image: "/assests/images/LandingPage/vendor/Opportunities1.webp", // Sample image

    },
    {
      title: "Earnings",
      description:
        "With our platform, installation partners enjoy the ease of instant payments for every job they perform. As soon as your work is approved, the funds are transferred directly to your account, ensuring stress-free experience",
      image: "/assests/images/LandingPage/vendor/SalaryCreditMockup.webp", // Sample image

    },
    // {
    //   title: "On Going Job",
    //   description:
    //     "We’re committed to leveraging the latest innovations in medical technology.",
    //   image: "/assests/images/LandingPage/vendor/ongoing jobs.png", // Sample image
    // },
  ];

  return (
    <div className="bg-black text-white py-16 px-6 md:px-16 rounded-3xl">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h3 className="text-sm uppercase tracking-widest text-gray-400">
            Features
          </h3>
          <h2 className="text-xl md:text-5xl font-bold mt-2">
            Everything your business needs,
          </h2>
          <span className="text-xl md:text-5xl font-bold mt-2">
            all bundled in one app.
          </span>
        </div>

        {/* Two-Column Layout */}
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Left Column: Image */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={imageSrc}
              alt="Mobile App"
              className="w-72 md:w-96 rounded-xl shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
              loading="lazy" // Lazy loading for images
            />
          </div>

          {/* Right Column: Features */}
          <div className="w-full md:w-1/2">
            <div className="space-y-6">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className={`p-6 rounded-lg cursor-pointer transition-all ${
                    activeFeature === feature.title
                      ? "bg-white text-black shadow-lg"
                      : "bg-gray-800 text-white hover:bg-white hover:text-black"
                  }`}
                  onMouseEnter={() => {
                    setActiveFeature(feature.title);
                    handleHover(feature.image, feature.title);
                  }}
                  //   onMouseLeave={handleMouseLeave}
                >
                  <h4 className="text-lg font-semibold">{feature.title}</h4>
                  <p className="text-gray-400 mt-2">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessAppSection;

